import { BeneficiaryStatus } from '../types';

const getStatusName = (status: string) => {
  let statusName;

  switch (status) {
    case BeneficiaryStatus.APPROVED:
      statusName = 'Approved';
      break;
    case BeneficiaryStatus.DRAFT:
      statusName = 'Draft';
      break;
    case BeneficiaryStatus.REJECTED:
      statusName = 'Rejected';
      break;
    case BeneficiaryStatus.UNDER_REVIEW:
      statusName = 'Under Review';
      break;
    default:
      statusName = status;
      break;
  }

  return statusName;
};

export default getStatusName;
